function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3h-15A1.502 1.502 0 003 4.5v15A1.502 1.502 0 004.5 21h15a1.502 1.502 0 001.5-1.5v-15A1.502 1.502 0 0019.5 3zm0 16.5h-15v-3.75h2.69L9 17.56a1.49 1.49 0 001.06.44h3.88a1.49 1.49 0 001.06-.44l1.81-1.81h2.691v3.75z",
    fill: props.fill
  }));
}

export default SvgTray;